import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LoginHashComponent } from './login-hash/login-hash.component';
import { RecoverPasswordComponent } from './recover-pass/recover-password/recover-password.component';
import { RecoverPasswordFinishComponent } from './recover-pass/recover-password-finish/recover-password-finish.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { RegistroIngresoModalComponent } from '@app/security/hidden-register/registro-ingreso-modal/registro-ingreso-modal.component';
import { SharedModule } from '@shared/shared.module';
import { UndercoverRegisterComponent } from './hidden-register/undercover-register/undercover-register.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { CreatePasswordComponent } from '@app/security/hidden-register/create-password/create-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VerifyAccountComponent } from '@app/security/verify-account/verify-account.component';
import { RegistroEncubiertoComponent } from './hidden-register/registro-encubierto/registro-encubierto.component';
import { RegistroSocialComponent } from './hidden-register/registro-social/registro-social.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { SignInModalComponent } from './modals/sign-in-modal/sign-in-modal.component';
import { LoginModalComponent } from './modals/login-modal/login-modal.component';
import { ManageConsentsComponent } from './manage-consents/manage-consents.component';
import { MatIconModule } from '@angular/material/icon';
import { SignInStepWelcomeComponent } from './modals/sign-in-modal/steps/sign-in-step-welcome/sign-in-step-welcome.component';
import { SignInStepRegisterComponent } from './modals/sign-in-modal/steps/sign-in-step-register/sign-in-step-register.component';
import { SignInStepAboutComponent } from './modals/sign-in-modal/steps/sign-in-step-about/sign-in-step-about.component';
import { SignInStepSurvey1Component } from './modals/sign-in-modal/steps/sign-in-step-survey-1/sign-in-step-survey-1.component';
import { SignInStepSurvey2Component } from './modals/sign-in-modal/steps/sign-in-step-survey-2/sign-in-step-survey-2.component';
import { SignInStepPreferencesComponent } from './modals/sign-in-modal/steps/sign-in-step-preferences/sign-in-step-preferences.component';
import { SignInStepSuccessComponent } from './modals/sign-in-modal/steps/sign-in-step-success/sign-in-step-success.component';
import { SignInStepSalerLocalizationComponent } from './modals/sign-in-modal/steps/sign-in-step-saler-localization/sign-in-step-saler-localization.component';
import { SignInStepSalerPropertyComponent } from './modals/sign-in-modal/steps/sign-in-step-saler-property/sign-in-step-saler-property.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    LoginHashComponent,
    RecoverPasswordComponent,
    RecoverPasswordFinishComponent,
    RegistroIngresoModalComponent,
    UndercoverRegisterComponent,
    CreatePasswordComponent,
    PageNotFoundComponent,
    VerifyAccountComponent,
    RegistroEncubiertoComponent,
    RegistroSocialComponent,
    SignInModalComponent,
    LoginModalComponent,
    ManageConsentsComponent,
    SignInStepWelcomeComponent,
    SignInStepRegisterComponent,
    SignInStepAboutComponent,
    SignInStepSurvey1Component,
    SignInStepSurvey2Component,
    SignInStepPreferencesComponent,
    SignInStepSuccessComponent,
    SignInStepSalerLocalizationComponent,
    SignInStepSalerPropertyComponent,
  ],
  exports: [
    RegistroIngresoModalComponent,
    RegistroEncubiertoComponent,
    SignInModalComponent,
    LoginModalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    FormsModule,
    SharedModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatDialogModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
  ],
})
export class SecurityModule {}
